import { type HttpHandler, HttpResponse, http } from 'msw';
import { type Product } from '../../../../utils/api/types/access-api-types';
import { prependApiBase } from '../../../../__test__/utils/prepend-api-base';
import { mockError } from '../../../../__test__/utils/msw-mock-error';

const getProductByAccessCodeApiUrl = () =>
  prependApiBase(`/products/access-code/:accessCode`, '/fulfillment', '/v2');

export const mockProductResponse: Product = {
  id: 'test-product-id',
  productCode: 'TEST123',
  productName: 'Test Product',
  thumbnailUrl: 'https://foo.com/thumbnail.jpg',
  applicationCode: 'test-product-app',
  applicationLabel: 'Test Product',
  parentApplication: 'test-product-app',
  gradeLow: 'K',
  gradeHigh: '5',
  description: 'A test product for demonstration',
  subtitle: 'Test Subtitle',
  accessType: 'subscription',
};

export const getProductByAccessCodeApiMock = (): HttpHandler =>
  http.get(getProductByAccessCodeApiUrl(), () =>
    HttpResponse.json(mockProductResponse)
  );

export const getProductByAccessCodeApiErrorMock = (): HttpHandler =>
  http.get(getProductByAccessCodeApiUrl(), mockError);

export const getProductByAccessCodeApiExpiredMock = (): HttpHandler =>
  http.get(
    getProductByAccessCodeApiUrl(),
    () =>
      new HttpResponse(
        JSON.stringify({
          code: 'access.code.expired',
          message: 'The access code has expired.',
        }),
        { status: 400, statusText: 'Bad Request' }
      )
  );

export const getProductByAccessCodeApiNotYetActiveMock = (): HttpHandler =>
  http.get(
    getProductByAccessCodeApiUrl(),
    () =>
      new HttpResponse(
        JSON.stringify({
          code: 'start.date.after.current.date',
          message: 'The access code is not yet active.',
        }),
        { status: 400, statusText: 'Bad Request' }
      )
  );
